import { gql } from '@apollo/client';

export const GET_DELIVERY_LIST = gql`
  query GetDeliveryListByFilter(
    $filter: DeliveryFilterInput!
    $page: Int
    $size: Int
  ) {
    delivery {
      deliveries(filter: $filter, page: $page, size: $size) {
        totalCount
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            id
            order {
              id
              items {
                id
                transaction {
                  id
                }
                dependedItems {
                  id
                  transaction {
                    id
                    type
                    firm
                    firmedAt
                    status
                  }
                  count
                  units {
                    id
                    indexNo
                  }
                }
                units(includeCancel: true) {
                  indexNo
                  replies {
                    id
                    indexNo
                    title
                    answer
                    selections {
                      label
                    }
                  }
                }
              }
            }
            customer {
              id
              nickname
              mobileNumber
              gender
            }
            cost {
              value
              currencyCode
            }
            items(includeCancel: true) {
              id
              count
              orderItem {
                transaction {
                  id
                }
              }
              info {
                id
                product {
                  id
                  title
                }
                name
                price {
                  sale
                  retail
                  currencyCode
                }
              }
            }
            recipient {
              name
              email
              mobileNo
              phoneNo
              address {
                selectedType
                zoneCode
                jibunAddress
                roadAddress
                buildingName
                addressDetail
              }
              note
            }
            createdAt
            packedAt
            issuedAt
            completedAt
            confirmedAt
            troubledAt
            troubleReason
            status
            courier {
              id
              name
            }
            trackingNo
          }
        }
      }
    }
  }
`;

//? 배송 준비
export const PACK_DELIVERIES = gql`
  mutation PackDeliveries($ids: [String!]!) {
    packDeliveries(ids: $ids) {
      id
      packedAt
      issuedAt
      completedAt
      confirmedAt
      troubledAt
      troubleReason
      status
    }
  }
`;

//? 배송 준비 철회
export const RESTREAT_PACKING_DELIVERIES = gql`
  mutation RetreatPackingDeliveries($ids: [String!]!) {
    retreatPackingDeliveries(ids: $ids) {
      id
      courier {
        id
        name
      }
      trackingNo
      packedAt
      issuedAt
      completedAt
      confirmedAt
      troubledAt
      troubleReason
      status
    }
  }
`;

//? 배송 출고
export const ISSUE_DELIVERIES = gql`
  mutation IssueDeliveries($trackingInfos: [TrackingInfoInput!]!) {
    issueDeliveries(trackingInfos: $trackingInfos) {
      id
      courier {
        id
        name
      }
      trackingNo
      packedAt
      issuedAt
      completedAt
      confirmedAt
      troubledAt
      troubleReason
      status
    }
  }
`;

//? 배송 완료
export const COMPLETE_DELIVERIES = gql`
  mutation CompleteDeliveries($ids: [String!]!) {
    completeDeliveries(ids: $ids) {
      id
      packedAt
      issuedAt
      completedAt
      confirmedAt
      troubledAt
      troubleReason
      status
    }
  }
`;

//? 구매 확정
export const CONFIRM_DELIVERIES = gql`
  mutation ConfirmDeliveries($ids: [String!]!) {
    confirmDeliveries(ids: $ids) {
      id
      courier {
        id
        name
      }
      trackingNo
      packedAt
      issuedAt
      completedAt
      confirmedAt
      troubledAt
      troubleReason
      status
    }
  }
`;
